export function showElement(el, forceHide) {
  if (el.style.display === 'none') { el.style.display = ''; }
}